import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { SearchSuggestionComponent } from './search-suggestion/search-suggestion.component';
import { InformationTileComponent } from './information-tile/information-tile.component';
import { InputRestrictionsDirective } from './directives/input-restrictions.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatSelectModule
  ],
  declarations: [
    SearchBarComponent,
    SearchSuggestionComponent,
    InformationTileComponent,
    InputRestrictionsDirective
  ],
  exports: [
    SearchBarComponent,
    SearchSuggestionComponent,
    InformationTileComponent
  ],
})
export class SkuSearchUiModule {}
